<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_iii"></a></p>
<h1 class="h1"><strong>BRUNETTI’S VENICE</strong></h1>
<p class="subtitle">Walks with the City’s Best-Loved Detective</p>
<p class="author">Toni Sepeda</p>
<p class="center">With an Introduction by Donna Leon</p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?430125ba